
import React from 'react';
import { IOpenSourceorganization } from './../../types';
import { RightOutlined } from '@ant-design/icons';

import './style.less';

const DeveloperOpenOrganization: React.FC<IOpenSourceorganization> = props => {
    const {  list = [] } = props;


    return (
        <div className="developer-open-partner-wrapper">
            
            <div className="open-object">- 开源组织/社区 -</div>
            <div className="open-partner-card-wrapper">
                {
                    list.map(item =>
                        <div className="open-partner-card" key={item.title}>
                            <img className="open-partner-icon" src={item.imageUrl} alt={item.title} />
                            <a href={item.link}>
                                <div className="open-partner-related-desc">
                                    <span>{item.desc}&nbsp;</span>
                                    <RightOutlined />
                                </div>
                            </a>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default DeveloperOpenOrganization;